import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonDisabled = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding disabled button"}
        value={' <Button variant={"noPadding"} disabled>Disabled</Button>'}
      >
        <Button variant={"noPadding"} disabled>
          Disabled
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonDisabled;
